import { render } from "./BatchCreate.vue?vue&type=template&id=18fed567"
import script from "./BatchCreate.vue?vue&type=script&lang=js"
export * from "./BatchCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__